(($, Drupal, once) => {
  function updateRequiredDocuments() {
    const includedDocuments = [];
    $('.field--name-field-document-type-ref select option:selected').each(
      function a() {
        includedDocuments.push($(this).text().trim());
      },
    );

    $('.field--name-field-document-type-ref .field__item').each(function a() {
      includedDocuments.push($(this).text().trim());
    });

    $(
      '.view-id-transfer_reason .views-row .views-field .field-content, .view-id-appeal_type_documents .views-row .views-field .field-content',
    ).each(function a() {
      if (includedDocuments.includes($(this).text().trim())) {
        if (!$(this).parents('.views-row').hasClass('doc-present')) {
          $(this).parents('.views-row').addClass('doc-present');
        }
      } else {
        $(this).parents('.views-row').removeClass('doc-present');
      }
    });
  }

  Drupal.behaviors.reqDocs = {
    attach(context) {
      updateRequiredDocuments();

      once(
        'reqDocs',
        '.srs-entity-student-transfer-add-form, .srs-entity-student-transfer-edit-form, .srs-entity-appeal-add-form, .srs-entity-appeal-edit-form',
        context,
      ).forEach(() => {
        $('#edit-group-supporting-documents, #required-documents').on(
          'change update',
          function a() {
            updateRequiredDocuments();
          },
        );
      });
    },
  };
})(jQuery, Drupal, once);
